<template id="CTAButton">
    <div class="quizier-module module-cta-form">
        <form-module @lead-captured="leadCaptured" :block_id="block_id" :post_id="postID" :data="form_data" />
    </div>
</template>
<script>
import mixinComponent from "../mixins";
import formModule from "../libs/ctaFormModule.vue";

export default {
    props: [],
    mixins: [mixinComponent],
    components: {
        formModule
    },
    computed: {
        form_data: function() {
            return this.blockData;
        },
        block_id: function() {
            return this.me.index;
        }
    },
    methods: {
        leadCaptured: function() {
            //'User has completed the lead form. Process something cool here.'
        }
    },
};
</script>